<template>
    <div class="settlement-edc-card">
        <div
            class="m-d-12 card-list-settlement"
            v-for="(data, idx) in listSettlementEdc"
            :key="`${idx}-${data.idsettlement}`"
        >
            <SOSlotCard
                :id="`card-settlement-${data.idsettlement}`"
                :last-id="getLastId"
                :card-type="typeCard"
                @loadMore="doLoadMore"
                @toogleCard="toogleCard"
            >
                <template v-slot:card_body>
                    <div class="f-c-midgrey f-regular" @click="gotoDetail(data.idsettlement)">
                        <div class="" v-if="isNeedConfirm(data)">
                            <p class="notice f-12">Menunggu konfirmasi</p>
                        </div>
                        <div class="d-flex-between-center f-16 f-semi f-c-black">
                            <p class="m-d-0">{{ data.nominal | currency }}</p>
                            <img src="../../../assets/icons/chevron_right_4.svg" />
                        </div>
                        <div class="f-13 f-regular f-c-midgrey">
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                class="m-d-8"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M1.16683 0.833334C1.62707 0.833334 2.00016 1.20643 2.00016 1.66667V6.77083C2.00016 7.32337 2.21966 7.85327 2.61036 8.24397C3.00106 8.63467 3.53096 8.85417 4.0835 8.85417H10.8217L8.59841 6.63092C8.27297 6.30549 8.27297 5.77785 8.59841 5.45241C8.92384 5.12697 9.45148 5.12697 9.77692 5.45241L13.4228 9.09824C13.7482 9.42368 13.7482 9.95132 13.4228 10.2768L9.77692 13.9226C9.45148 14.248 8.92384 14.248 8.59841 13.9226C8.27297 13.5972 8.27297 13.0695 8.59841 12.7441L10.8217 10.5208H4.0835C3.08893 10.5208 2.13511 10.1257 1.43185 9.42248C0.728584 8.71922 0.333496 7.7654 0.333496 6.77083V1.66667C0.333496 1.20643 0.706592 0.833334 1.16683 0.833334Z"
                                    fill="#6F7287"
                                />
                            </svg>
                            <span class="m-l-8">Ke {{ data.nama_rekening }}</span>
                        </div>
                    </div>
                </template>
                <template v-slot:card_footer>
                    <div class="footer" :class="{ needConfirm: isNeedConfirm(data) }">
                        <div
                            class="m-d-0 f-12 f-regular f-c-black d-grid-12"
                            style="padding: 8px 18px 10px; align-items: center;"
                        >
                            <label class="m-d-0 grid-cspan-1" style="width:fit-content"> Oleh </label>
                            <label class="m-d-0 grid-cspan-4 f-cont">
                                <b class="nama-kasir">{{ getNamaKaryawan(data) }}</b>
                            </label>
                            <label class="m-d-0 grid-cspan-4 j-self-end f-cont" style="text-align: right;">
                                ({{ data.tanggal_settlement_formated }})
                            </label>
                            <label
                                v-if="!isNeedConfirm(data)"
                                class="m-d-0 grid-cspan-3 j-self-end statusBagde"
                                :class="{
                                    approveBagde: getStatus(data) === 'Disetujui',
                                    declineBagde: getStatus(data) === 'Ditolak',
                                }"
                            >
                                {{ getStatus(data) }}
                            </label>
                        </div>
                    </div>
                </template>
            </SOSlotCard>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotCard from "@/so-components/global/slot/SOSlotCard.vue";

import { moduleName } from "../store/state";

export default {
    name: "SOCardSettlementEdc",
    props: {
        typeCard: {
            type: String,
            default: "shadow",
        },
        search: {
            type: Object,
        },
    },
    components: {
        SOSlotCard,
    },
    computed: {
        ...mapGetters(moduleName, {
            listSettlementEdc: "listSettlementEdc",
            totalSettlementEdc: "totalSettlementEdc",
            paginationSettlement: "paginationSettlement",
            isFetching: "isFetching",
            endSettlementOfPage: "endSettlementOfPage",
        }),
        getLastId() {
            return this.endSettlementOfPage.idsettlement ? `card-settlement-${this.endSettlementOfPage.idsettlement}` : "";
        },
        getNamaKaryawan() {
            return (data) => {
                return data.nama_karyawan ? data.nama_karyawan : "Owner";
            };
        },
        isNeedConfirm() {
            return (data) => {
                return data.status === 0 ? true : false;
            };
        },
        getStatus() {
            return (data) => {
                return data.status === 1 ? "Disetujui" : data.status === 2 ? "Ditolak" : "";
            };
        },
    },
    methods: {
        ...mapActions({
            setLoadMore: `${moduleName}/setLoadMore`,
            getListSettlementEdc: `${moduleName}/getListSettlementEdc`,
            toogleDisplayCard: `${moduleName}/toogleDisplayCard`,
        }),
        async doLoadMore() {
            if (this.totalSettlementEdc > this.paginationSettlement.length) {
                if (!this.isFetching) {
                    await this.setLoadMore(true);
                    await this.getListSettlementEdc(this.search);
                }
            }
        },
        toogleCard(data) {
            this.toogleDisplayCard(data);
        },
        gotoDetail(id) {
            this.$router.push({ name: "mesin.edc.detail.setoran", params: { id_settlement: id } });
        },
    },
};
</script>

<style scoped>
.notice {
    background: #ededed;
    width: fit-content;
    padding: 2px 4px;
    border-radius: 3px;
}

.nama-kasir {
    max-width: 50%;
    margin-bottom: 0px;
    margin: 0px 4px;
}

.footer {
    margin: -8px -18px -10px;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
}

.needConfirm {
    background: linear-gradient(90deg, #fff8e1 0%, #ffffff 100%);
}

.statusBagde {
    justify-self: end;
    padding: 2px 8px;
    border-radius: 25px;
}

.approveBagde {
    background-color: #e8fcee;
}

.declineBagde {
    background-color: #fff1f1;
}
</style>
